import React from "react";
import { PieceInfoGroupProps } from "./pieceInfoGroup";
import ThreePartList, { ThreePartListElement } from "../../../components/threePartList";
import DrawIcon from "../../../assets/icons/drawIcon";
import DownloadIcon from "../../../assets/icons/downloadIcon";
import CategoryIcon from "../../../assets/icons/categoryIcon";
import HourglassIcon from "../../../assets/icons/hourglassIcon";
import ClockIcon from "../../../assets/icons/clockIcon";
import { formatDate } from "../../../utils/dateUtils";
import OriginalIcon from "../../../assets/icons/originalIcon";
import TranscriptionIcon from "../../../assets/icons/transcriptionIcon";
import PagesIcon from "../../../assets/icons/pagesIcon";
import ChapterIcon from "../../../assets/icons/chapterIcon";

export default function StatsPieceInfoGroup(props: PieceInfoGroupProps) {

    const elements = [
        new ThreePartListElement(
            <ClockIcon/>,
            "Published",
            formatDate(new Date(props.piece.uploadDate))
        ),
        new ThreePartListElement(
            <DrawIcon/>,
            "Written",
            props.piece.year + ""
        ),
        new ThreePartListElement(
            <DownloadIcon/>,
            "Downloads",
            props.piece.downloads + ""
        ),
        new ThreePartListElement(
            <PagesIcon/>,
            "Pages",
            props.piece.pages + ""
        ),
        new ThreePartListElement(
            <HourglassIcon/>,
            "Length",
            "~" + props.piece.duration + " Minutes"
        ),
        new ThreePartListElement(
            props.piece.original ? <OriginalIcon/> : <TranscriptionIcon/>,
            "Type",
            props.piece.original ? "Original" : "Transcription"
        ),
        new ThreePartListElement(
            <CategoryIcon/>,
            "Category",
            props.piece.difficulty ? "Concert" : "Pedagogic"
        )
    ];

    if(props.piece.movements && props.piece.movements.length > 0) {
        elements.push(new ThreePartListElement(
            <ChapterIcon/>,
            "Movements",
            props.piece.movements.length + ""
        ));
    }

    return <ThreePartList elements={elements}/>;

}